// src/pages/Companies/index.tsx
import { Container, Title } from "./styles";

export default function Companies() {
  return (
    <Container>
      <Title>Listagem de empresas</Title>
    </Container>
  );
}
